
require("./../../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import React from 'react';
import { GetServerSideProps } from 'next';

import { getBasicPageContentServerProps, parseBasicPageContent } from '../../common/basicContent';
import { SSR_PAGE_CACHE } from 'common/constants';

const BASE_ROUTE = `policies`;

type Props = {
  content: string; // JSON string value
};

const PoliciesPage: React.FC<Props> = ({ content }: Props) => {
  return <>{parseBasicPageContent(content)}</>;
};

export const getServerSideProps: GetServerSideProps = async context => {
  if (context.query?.preview === undefined) {
    context.res.setHeader('Cache-Control', SSR_PAGE_CACHE);
  }

  return await getBasicPageContentServerProps(context, BASE_ROUTE);
};

export default PoliciesPage;
